(() => {
  const root = document.getElementById('far-experience');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const app = root.querySelector('[data-far-app]');
  const main = root.querySelector('#far-main');
  const enter = root.querySelector('[data-enter]');
  const toast = root.querySelector('[data-toast]');
  const dialog = root.querySelector('[data-dialog]');
  const dialogContent = root.querySelector('[data-dialog-content]');
  const achievementList = root.querySelector('[data-achievement-list]');
  const achievementCount = root.querySelector('[data-achievement-count]');
  const storageKey = 'lm_farr_discoveries_v1';
  const discoveries = new Set();
  let toastTimer;
  let audio;
  let soundNodes = [];

  root.style.setProperty('--far-truck', `url("${root.dataset.truckImage}")`);
  root.style.setProperty('--far-dragster', `url("${root.dataset.dragsterImage}")`);
  document.querySelectorAll('.site-header, #shopify-section-footer, .footbar-fixed, #login-mobile, #cart-mobile').forEach((element) => {
    element.inert = true;
    element.setAttribute('aria-hidden', 'true');
  });

  try {
    JSON.parse(localStorage.getItem(storageKey) || '[]').forEach((item) => discoveries.add(item));
  } catch (_) {}

  const achievementNames = {
    access: ['Back-room privileges', 'Held the button and accepted the consequences.'],
    light: ['Not asleep at the tree', 'Recorded a reaction time without leaving early.'],
    redlight: ['Bulb tester', 'Confirmed that the red light does, in fact, work.'],
    dyno: ['Certified dyno mathematician', 'Corrected horsepower for ego and humidity.'],
    socket: ['Found the 10mm', 'It was under something obvious the whole time.'],
    locker: ['Textile smuggler', 'Opened locker 1320 without calling a locksmith.'],
    chaos: ['Executive override', 'Pressed the button clearly labeled not to press.']
  };

  function persist() {
    try { localStorage.setItem(storageKey, JSON.stringify([...discoveries])); } catch (_) {}
  }

  function renderAchievements() {
    achievementCount.textContent = `${discoveries.size} / ${Object.keys(achievementNames).length}`;
    achievementList.innerHTML = Object.entries(achievementNames).map(([id, text]) => (
      `<li><strong>${discoveries.has(id) ? '✓' : '○'} ${text[0]}</strong>${discoveries.has(id) ? text[1] : 'Classified until discovered.'}</li>`
    )).join('');
  }

  function showToast(message) {
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  function unlock(id) {
    if (discoveries.has(id)) return;
    discoveries.add(id);
    persist();
    renderAchievements();
    showToast(`DISCOVERY UNLOCKED // ${achievementNames[id][0]}`);
  }

  function openDialog(html) {
    dialogContent.innerHTML = html;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  renderAchievements();
  document.documentElement.style.scrollBehavior = 'smooth';

  let holdFrame;
  let holdStarted = 0;
  const holdDuration = 1150;
  function cancelHold() {
    cancelAnimationFrame(holdFrame);
    holdStarted = 0;
    enter.style.setProperty('--hold', '0%');
  }
  function progressHold(now) {
    if (!holdStarted) holdStarted = now;
    const progress = Math.min(1, (now - holdStarted) / holdDuration);
    enter.style.setProperty('--hold', `${progress * 100}%`);
    if (progress < 1) {
      holdFrame = requestAnimationFrame(progressHold);
      return;
    }
    root.classList.add('is-entered');
    app.removeAttribute('aria-hidden');
    root.querySelector('[data-far-boot]').setAttribute('aria-hidden', 'true');
    main.focus({ preventScroll: true });
    unlock('access');
  }
  enter.addEventListener('pointerdown', (event) => { event.preventDefault(); holdFrame = requestAnimationFrame(progressHold); });
  enter.addEventListener('pointerup', cancelHold);
  enter.addEventListener('pointercancel', cancelHold);
  enter.addEventListener('pointerleave', cancelHold);
  enter.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      root.classList.add('is-entered');
      app.removeAttribute('aria-hidden');
      main.focus({ preventScroll: true });
      unlock('access');
    }
  });

  const clock = root.querySelector('[data-clock]');
  const tick = () => { clock.textContent = new Date().toLocaleTimeString([], { hour12: false }); };
  tick();
  window.setInterval(tick, 1000);

  let telemetry = 0;
  window.setInterval(() => {
    telemetry += 1;
    root.querySelector('[data-wallet]').textContent = String(Math.max(0, 2 - telemetry % 3)).padStart(2, '0');
    root.querySelector('[data-horsepower]').textContent = [742, 811, 903, '???'][telemetry % 4];
  }, 2300);

  const smoke = root.querySelector('[data-smoke]');
  function burnout() {
    root.classList.remove('is-shaking');
    void root.offsetWidth;
    root.classList.add('is-shaking');
    for (let i = 0; i < 34; i += 1) {
      const puff = document.createElement('i');
      puff.style.left = `${Math.random() * 100}%`;
      puff.style.setProperty('--size', `${80 + Math.random() * 190}px`);
      puff.style.setProperty('--drift', `${-170 + Math.random() * 340}px`);
      puff.style.animationDelay = `${Math.random() * .45}s`;
      smoke.appendChild(puff);
      window.setTimeout(() => puff.remove(), 3400);
    }
    showToast('TIRE BUDGET CONVERTED TO ATMOSPHERE');
  }
  root.querySelector('[data-burnout]').addEventListener('click', burnout);

  const tree = root.querySelector('.far-tree');
  const stage = root.querySelector('[data-stage]');
  const reaction = root.querySelector('[data-reaction]');
  const reactionCopy = root.querySelector('[data-reaction-copy]');
  let treeState = 'idle';
  let greenAt = 0;
  let treeTimers = [];
  function clearTree() { treeTimers.forEach(window.clearTimeout); treeTimers = []; }
  function setTreeStep(step, delay) { treeTimers.push(window.setTimeout(() => { tree.dataset.step = step; }, delay)); }
  function startTree() {
    clearTree();
    treeState = 'counting';
    tree.dataset.step = 'pre';
    reaction.textContent = '-.---';
    reactionCopy.textContent = 'Staged. Try not to think about it.';
    stage.textContent = 'LAUNCH';
    const suspense = 650 + Math.random() * 1150;
    setTreeStep('1', suspense);
    setTreeStep('2', suspense + 420);
    setTreeStep('3', suspense + 840);
    treeTimers.push(window.setTimeout(() => {
      tree.dataset.step = 'go';
      treeState = 'green';
      greenAt = performance.now();
    }, suspense + 1260));
  }
  function launch() {
    if (treeState === 'counting') {
      clearTree();
      tree.dataset.step = 'red';
      treeState = 'idle';
      reaction.textContent = '-.001';
      reactionCopy.textContent = 'RED LIGHT. Tremendous confidence. Catastrophic timing.';
      stage.textContent = 'STAGE AGAIN';
      unlock('redlight');
      return;
    }
    if (treeState === 'green') {
      const time = (performance.now() - greenAt) / 1000;
      reaction.textContent = time.toFixed(3);
      reactionCopy.textContent = time < .19 ? 'Suspiciously sharp. We are checking your browser for delay box software.' : time < .45 ? 'Solid light. The hot dog can wait.' : time < .8 ? 'You left when the green felt emotionally correct.' : 'Were you tightening the belts or writing a will?';
      treeState = 'idle';
      stage.textContent = 'STAGE AGAIN';
      unlock('light');
      return;
    }
    startTree();
  }
  stage.addEventListener('click', launch);

  const hpRange = root.querySelector('[data-hp-range]');
  const hpOutput = root.querySelector('[data-hp-output]');
  const gauge = root.querySelector('[data-gauge]');
  hpRange.addEventListener('input', () => { hpOutput.textContent = `${Number(hpRange.value).toLocaleString()} HP`; });
  root.querySelector('[data-dyno]').addEventListener('click', () => {
    const claimed = Number(hpRange.value);
    const truthFactor = .64 + Math.random() * .25;
    const actual = Math.round(claimed * truthFactor);
    const difference = claimed - actual;
    const angle = -130 + Math.min(245, actual / 2500 * 245);
    gauge.style.setProperty('--needle', `${angle}deg`);
    root.querySelector('[data-dyno-result] strong').textContent = `${actual.toLocaleString()} wheel-ish HP. We located ${difference.toLocaleString()} missing horsepower in a forum signature.`;
    unlock('dyno');
  });

  const diagnoses = {
    noise: ['PROBABLE CAUSE: the part you said “should be fine.”', 'Shut it down. Inspect it properly. If metal has become glitter, congratulations on your new shopping list.'],
    leak: ['FLUID IDENTIFICATION: expensive.', 'Do not taste it. Put the vehicle somewhere safe, find the source and fix the actual problem instead of adding another quart forever.'],
    start: ['SYSTEM CHECK: battery, fuel, spark, pride.', 'Start with the boring basics. The problem is statistically under the thing you replaced first.'],
    fast: ['DIAGNOSIS: calibration fault in driver ego sensor.', 'Verify with a time slip. Gas-station horsepower is not recognized by any sanctioning body.']
  };
  root.querySelectorAll('[data-diagnose]').forEach((button) => button.addEventListener('click', () => {
    const result = diagnoses[button.dataset.diagnose];
    root.querySelector('[data-diagnostic-readout]').innerHTML = `<span>SCAN COMPLETE // NO CUSTOMER DATA WAS HARMED</span><strong>${result[0]}</strong><p>${result[1]}</p>`;
  }));

  let code = '';
  const codeOutput = root.querySelector('[data-code]');
  const lockMessage = root.querySelector('[data-lock-message]');
  function drawCode() { codeOutput.textContent = `${code.split('').join(' ')}${code.length < 4 ? `${code ? ' ' : ''}${'_ '.repeat(4 - code.length).trim()}` : ''}`; }
  root.querySelectorAll('[data-keypad] button:not([data-key-clear]):not([data-key-enter])').forEach((button) => button.addEventListener('click', () => {
    if (code.length < 4) code += button.textContent.trim();
    drawCode();
  }));
  root.querySelector('[data-key-clear]').addEventListener('click', () => { code = ''; drawCode(); });
  root.querySelector('[data-key-enter]').addEventListener('click', () => {
    if (code === '1320') {
      root.querySelector('[data-locker]').classList.add('is-open');
      root.querySelector('[data-merch-inside]').removeAttribute('aria-hidden');
      lockMessage.textContent = 'OPEN // accounting has been temporarily distracted';
      unlock('locker');
    } else {
      lockMessage.textContent = code === '0000' ? 'DENIED // that is your checking account, not the code' : 'DENIED // try the full length of the drag strip';
      code = '';
      drawCode();
    }
  });

  root.querySelector('[data-prototype]').addEventListener('click', (event) => {
    event.currentTarget.textContent = 'Interest noted locally on this device ✓';
    showToast('NO DATA SENT // NO INVENTORY INVENTED // OWNER NOW KNOWS THE SHIRT SHOULD EXIST');
  });

  root.querySelector('[data-bolt]').addEventListener('click', () => {
    root.querySelector('[data-sockets]').textContent = '01';
    unlock('socket');
    openDialog('<p class="far-kicker">LOST & FOUND / BIN 10MM</p><h2>You found the socket.</h2><p>It was under a loose decorative bolt on a website. This makes as much sense as where it usually turns up.</p><p><code>SHOP NOTE: return it to the drawer, you animal.</code></p>');
  });

  function getAudio() {
    audio ||= new (window.AudioContext || window.webkitAudioContext)();
    if (audio.state === 'suspended') audio.resume();
    return audio;
  }
  function stopSound() {
    soundNodes.forEach((node) => { try { node.stop(); } catch (_) {} });
    soundNodes = [];
    root.querySelector('[data-radio-copy]').textContent = 'PA SYSTEM: mercifully idle';
  }
  function tone(type) {
    stopSound();
    const ctx = getAudio();
    const now = ctx.currentTime;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(.0001, now);
    gain.gain.exponentialRampToValueAtTime(.12, now + .04);
    gain.gain.exponentialRampToValueAtTime(.0001, now + (type === 'engine' ? 2.3 : 1.2));
    gain.connect(ctx.destination);
    if (type === 'engine') {
      [48, 72, 96].forEach((frequency, index) => {
        const oscillator = ctx.createOscillator();
        oscillator.type = index ? 'sawtooth' : 'square';
        oscillator.frequency.setValueAtTime(frequency, now);
        oscillator.frequency.exponentialRampToValueAtTime(frequency * 3.3, now + 1.8);
        oscillator.connect(gain);
        oscillator.start(now + index * .02);
        oscillator.stop(now + 2.35);
        soundNodes.push(oscillator);
      });
      root.querySelector('[data-radio-copy]').textContent = 'ENGINE LAB: sounds expensive from here';
    } else {
      const oscillator = ctx.createOscillator();
      oscillator.type = 'square';
      const pattern = type === 'advisor' ? [880, 440, 880, 440] : [660, 820, 660];
      pattern.forEach((frequency, index) => oscillator.frequency.setValueAtTime(frequency, now + index * .19));
      oscillator.connect(gain);
      oscillator.start(now);
      oscillator.stop(now + 1.25);
      soundNodes.push(oscillator);
      root.querySelector('[data-radio-copy]').textContent = type === 'advisor' ? 'ALERT: hide the receipt folder' : 'PA: whoever has the 10mm, your mother raised you better';
    }
  }
  root.querySelectorAll('[data-sound]').forEach((button) => button.addEventListener('click', () => {
    if (button.dataset.sound === 'silence') stopSound();
    else tone(button.dataset.sound);
  }));

  root.querySelector('[data-memo]').addEventListener('click', () => openDialog(`
    <p class="far-kicker">INTERCEPTED MEMO // 2:13 A.M.</p>
    <h2>To: everybody still in the shop</h2>
    <p><strong>Subject: “quick pass tomorrow”</strong></p>
    <p>The vehicle currently has no transmission, the trailer has one tire with a personal grudge, and somebody used the last clean shop rag to polish a wheel that is not mounted to anything.</p>
    <ol><li>Stop saying “we’re basically done.”</li><li>Find the 7/16 wrench.</li><li>Charge the jump box.</li><li>Do not wake the person asleep in the tow vehicle unless something is actively on fire.</li></ol>
    <p><code>Management response: approved. See you at the track.</code></p>
  `));

  root.querySelector('[data-tiny]').addEventListener('click', () => {
    unlock('chaos');
    burnout();
    openDialog('<p class="far-kicker">EXECUTIVE OVERRIDE ACCEPTED</p><h2>Why the fuck did they build all of this?</h2><p>Because normal stores do not have reaction-time games, a local achievement system, a synthesized big-block impersonation and a four-digit contraband locker hiding inside a Shopify page.</p><p><strong>Also because somebody said “run wild.”</strong></p>');
  });

  root.querySelector('[data-achievements-toggle]').addEventListener('click', () => root.querySelector('[data-achievements]').classList.toggle('is-open'));
  root.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });

  let keySequence = '';
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog.open) dialog.close();
    keySequence = `${keySequence}${event.key.toLowerCase()}`.slice(-6);
    if (keySequence === 'sendit') {
      showToast('TERMINAL COMMAND ACCEPTED // SEND IT PROTOCOL ARMED');
      burnout();
      keySequence = '';
    }
  });
})();
